import {Component, inject, OnInit} from '@angular/core';
import {AppContext} from '../../app-context';
import {AuthService} from "../../utils/auth.service";
import {Handler} from "src/app/common/handler";
import {View} from "src/app/common/view";
import {WebsocketService} from "../../common/websocket.service";
import {UiUpdate} from '@flowmaps-com/flowmaps-typescriptmodels';
import {publishEvent, subscribeTo} from "../../common/app-common-utils";

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.css']
})
@Handler()
export class HomeComponent extends View implements OnInit {
    context = AppContext;
    private authService: AuthService = inject(AuthService);
    private socketService: WebsocketService<UiUpdate> = inject(WebsocketService<UiUpdate>);
    private socketInitialised = false;

    ngOnInit(): void {
        if (!this.authService.ensureValidSession()) {
            return;
        }
        subscribeTo("com.flowmaps.api.user.GetUserProfile").subscribe({
            next: userProfile => {
                if (!userProfile) {
                    this.authService.invalidateSession("missing-user-profile");
                    return;
                }
                if (!this.authService.ensureValidSession()) {
                    return;
                }
                AppContext.setUserProfile(userProfile);
                if (!this.socketInitialised && !AppContext.isHeadlessChrome()) {
                    this.socketInitialised = true;
                    this.socketService.initialise("api/updates", update => publishEvent(update.type, update));
                }
            },
            error: () => this.authService.invalidateSession("user-profile-error")
        });
    }
}
